import React from 'react';
import { TextField } from './TextField';
import PropTypes from 'prop-types';

export class URLTextField extends React.Component {
  static propTypes = {
    validationRules: PropTypes.arrayOf(PropTypes.object),
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    value: PropTypes.string,
  };

  onBlur = (event) => {
    const { validationRules, value, onBlur, onChange } = this.props;
    if (validationRules && validationRules.some((rule) => !rule.func(value))) {
      return;
    } else if (value && value.trim() && !/^(?:f|ht)tps?:\/\//.test(value)) {
      onChange(`https://${value}`);
    }
    if (onBlur) {
      onBlur(event);
    }
  };

  render() {
    return <TextField {...this.props} onBlur={this.onBlur} />;
  }
}
